import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { PropType } from 'vue';
import { computed, toRefs } from 'vue';
import { User } from 'firebase/auth';
import { defaultUserImages } from '@/util/placeholders';
import { getInitials } from '@/util/funcs';
import { UserName } from '@/models';


export default /*#__PURE__*/_defineComponent({
  props: {
  user: {
    type: Object as PropType<UserName>,
    required: false,
  },
  isMessageFromBuyer: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props


const { user } = toRefs(props);

const handleImageError = (event: Event) => {
  (event.target as HTMLImageElement).src = defaultUserImages();
};
// const photoURL = computed(() => user?.value?.photoURL || '');
const displayName = computed(() => `${user?.value?.firstName} ${user?.value?.lastName}`.trim() || '');
const initials = computed(() => getInitials(user?.value?.firstName, user?.value?.lastName));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(['inline-flex items-center justify-center rounded-full', !__props.isMessageFromBuyer? 'bg-wrh-blue-400 t-14m lg:t-16m font-bold text-white': 'bg-white text-wrh-blue-light' ])
  }, _toDisplayString(_unref(initials)), 3))
}
}

})